export default __webpack_public_path__ + "static/media/doctor1.d4037539.jpg";